import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import Assignee from "../../../../../models/Assignee";
import * as aggregatedStats from "./aggregatedStats";
import * as questionStats from "./questionStats";
import * as sectionStats from "./sectionStats";

export function getStatus(state: Assignee) {
  return state.get("status");
}

export function getAggregatedStats(state: Assignee) {
  return state.get("aggregatedStats");
}

export function getSectionStats(state: Assignee) {
  return state.get("sectionStats");
}

export function getQuestionStats(state: Assignee) {
  return state.get("questionStats");
}

export const { getIndividualSectionStats } = composeSelectors(
  getSectionStats,
  sectionStats as any
);

export const { getIndividualQuestionStats } = composeSelectors(
  getQuestionStats,
  questionStats as any
);

export const {
  getTotalStudyTime,
  getAverageScore,
  getAverageNumberOfAttempts,
  getAverageStudyTime,
  getAverageBestScore,
  getAverageWorstScore,
  getAverageFirstScore,
  getAverageLastScore,
  getSumQuestionMarks,
  getSumQuestionMarksTotal
  //@ts-ignore
} = composeSelectors(getAggregatedStats, aggregatedStats);
